export const styles = {
  dialog: {
    borderRadius: '12px',
    minWidth: '650px',
  },
  dialogContent: {
    overflowY: 'auto',
    scrollbarWidth: 'thin',
    scrollbarColor: '#fff',

    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#4D6EF5',
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: '#fff',
    },
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  error: {
    height: '20vh',
  },
};
